// Game phase durations in seconds - keep in sync with backend
export const PHASE_DURATIONS = {
  REVEAL_SECONDS: 30,
  NEGOTIATION_SECONDS: 300,  // 5 minutes
  RESULT_SECONDS: 20
};

export const formatDuration = (seconds) => {
  if (seconds >= 60) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    if (remainingSeconds === 0) {
      return `${minutes}分`;
    }
    return `${minutes}分${remainingSeconds}秒`;
  }
  return `${seconds}秒`;
};

export const PHASE_MESSAGES = {
  REVEAL: `公開フェーズ開始！${formatDuration(PHASE_DURATIONS.REVEAL_SECONDS)}以内に4枚選択`,
  NEGOTIATION: `交渉フェーズ開始！${formatDuration(PHASE_DURATIONS.NEGOTIATION_SECONDS)}間交渉可能`
};

